import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90acf6a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { "data-test": "camera-list" }
const _hoisted_3 = {
  class: "camera_list_tile_wrap",
  "data-test": "camera-list-tile"
}
const _hoisted_4 = {
  key: 0,
  "data-test": "camera-map"
}

import CameraListRow from '@/components/molecules/CameraListRow'
import CameraListTile from '@/components/molecules/CameraListTile'
import Maps from '@/components/organisms/Map'
import WhiteBox from '@/components/atoms/WhiteBox'
import Pagination from '@/components/molecules/Pagination'
import ZeroItem from '@/components/pages/Cameras/components/ZeroItem'
import CameraDetailDialog from '@/components/organisms/CameraDetailDialog'
import http from '@/js/utils/http'
import API from '@/js/const/api'
import { onMounted, withDefaults, computed, ref, watch } from 'vue'
import { CameraDetail } from '@/@types/typescript-axios'
import { AxiosResponse } from 'axios'

type PropsType = {
  /** 表示するカメラ一覧 */
  cameraList: CameraDetail[]
  /** 表示形式（list / tile / map） */
  displayType: string
  /** チェックボックスを表示するか */
  displayCheckBox: boolean
  /** 全選択状態 */
  useAllCheck: boolean
  /** カメラ総件数 */
  totalCameras: number
  /** 現在のページ番号 */
  currentPage: number
  /** 1ページあたりの表示件数 */
  pageSize: number
  /** trueのとき地図上の選択カメラをクリアする */
  noSelectCamera: boolean
  /** 一覧の種別（例: cameras）。マップナビ表示判定などに使用 */
  listType: string | null
  /** 親で保持している選択済みカメラ */
  checkedCameras: CameraDetail[]
  /** 故障カメラ条件の表示用フラグ */
  downCameraCondition: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraList',
  props: {
    cameraList: null,
    displayType: { default: 'list' },
    displayCheckBox: { type: Boolean, default: false },
    useAllCheck: { type: Boolean, default: false },
    totalCameras: { default: 50 },
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    noSelectCamera: { type: Boolean, default: true },
    listType: { default: null },
    checkedCameras: null,
    downCameraCondition: { type: Boolean, default: false }
  },
  emits: ["cameraChecked", "openMap", "setTag", "changePage", "clearFilter"],
  setup(__props: any, { emit }: { emit: ({
  /** チェック状態が変わったとき、選択中カメラ一覧を通知 */
  (e: 'cameraChecked', checkedCameras: CameraDetail[]): void
  /** マップ表示への切り替えを通知 */
  (e: 'openMap'): void
  /** 個別カメラのタグ設定を通知 */
  (e: 'setTag', cameraData: CameraDetail): void
  /** ページ変更を通知 */
  (e: 'changePage', page: number): void
  /** 検索条件クリアを通知 */
  (e: 'clearFilter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { cameraList: CameraDetail[], displayType: string, displayCheckBox: boolean, useAllCheck: boolean, totalCameras: number, currentPage: number, pageSize: number, noSelectCamera: boolean, listType: string | null, checkedCameras: CameraDetail[], downCameraCondition: boolean };

onMounted(() => {
  // チェックボックスの初期値を設定
  setCheckedStatuses(false)
})



/** カメラコードごとのチェック状態 */
const checkedStatuses = ref<{ [key: string]: boolean }>({})
/** 地図表示時にフォーカスするカメラ */
const selectCamera = ref<CameraDetail | null>(null)
/** カメラ詳細ダイアログの表示フラグ */
const showCameraInfoDialogFlag = ref<boolean>(false)
/** カメラ詳細ダイアログに渡すデータ */
const cameraInfoData = ref<CameraDetail | {}>({})



/** 該当カメラが0件かどうか */
const isZeroItem = computed<boolean>(() => props.totalCameras === 0)

/**
 * 表示中カメラのチェック状態を一括更新する
 * ref全体を差し替えてリアクティビティを発火させる
 * @param v 設定するチェック状態
 */
const setCheckedStatuses = (v: boolean) => {
  const next = { ...checkedStatuses.value }
  props.cameraList.forEach((d) => {
    next[d.camera_code] = v
  })
  checkedStatuses.value = next
}

/**
 * チェック状態の変更を親へ通知する
 */
const update = () => {
  // 選択済みのカメラだけ抽出
  const checkedCameras = props.cameraList.filter((d) => {
    return checkedStatuses.value[d.camera_code]
  })

  emit('cameraChecked', checkedCameras)
}

/**
 * 指定カメラを選択し、マップ表示を親へ通知する
 * @param cameraData マップでフォーカスするカメラ
 */
const openMap = (cameraData: CameraDetail) => {
  selectCamera.value = cameraData
  emit('openMap')
}

/**
 * カメラ詳細情報ダイアログを表示する
 * @param code カメラコード
 */
const showCameraInfoDialog = (code: string) => {
  const detailApi = API.CAMERA_DETAIL.replace('{camera_code}', code)

  // 映像詳細情報を取得
  http.get(detailApi).then((res: AxiosResponse) => {
    cameraInfoData.value = res.data.data
    showCameraInfoDialogFlag.value = true
  })
}

/** 全選択状態の変更に合わせてチェック状態を更新 */
watch(
  () => props.useAllCheck,
  (v) => {
    setCheckedStatuses(v)
  }
)

/** 選択解除フラグが立ったらマップの選択カメラをクリア */
watch(
  () => props.noSelectCamera,
  (b) => {
    if (b) {
      selectCamera.value = null
    }
  }
)

/** 親の選択カメラ一覧に合わせてローカルのチェック状態を同期 */
watch(
  () => props.checkedCameras,
  (checkedCameras) => {
    const next = { ...checkedStatuses.value }
    props.cameraList.forEach((d) => {
      next[d.camera_code] = checkedCameras.includes(d)
    })
    checkedStatuses.value = next
  }
)

return (_ctx: any,_cache: any) => {
  return (!_unref(isZeroItem))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cameraList, (camera, index) => {
            return (_openBlock(), _createBlock(_unref(CameraListRow), {
              cameraData: camera,
              key: index,
              displayCheckBox: __props.displayCheckBox,
              checked: checkedStatuses.value[camera.camera_code],
              "onUpdate:checked": [($event: any) => ((checkedStatuses.value[camera.camera_code]) = $event), update],
              listType: __props.listType,
              downCameraCondition: __props.downCameraCondition,
              onSetTag: _cache[0] || (_cache[0] = ($event: any) => (emit('setTag', $event))),
              onOpenMap: openMap,
              onShowCameraInfoDialog: showCameraInfoDialog
            }, null, 8, ["cameraData", "displayCheckBox", "checked", "onUpdate:checked", "listType", "downCameraCondition"]))
          }), 128))
        ], 512), [
          [_vShow, __props.displayType === 'list']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(WhiteBox), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cameraList, (camera, index) => {
                return (_openBlock(), _createBlock(_unref(CameraListTile), {
                  cameraData: camera,
                  key: index
                }, null, 8, ["cameraData"]))
              }), 128))
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, __props.displayType === 'tile']
        ]),
        (__props.displayType === 'map')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(WhiteBox), { class: "map_white_box" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Maps), {
                    cameraList: __props.cameraList,
                    totalCameras: __props.totalCameras,
                    pageSize: __props.pageSize,
                    currentPage: __props.currentPage,
                    selectCamera: selectCamera.value,
                    onChangePage: _cache[1] || (_cache[1] = ($event: any) => (emit('changePage', $event)))
                  }, null, 8, ["cameraList", "totalCameras", "pageSize", "currentPage", "selectCamera"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_unref(Pagination), {
          total: __props.totalCameras,
          pageSize: __props.pageSize,
          currentPage: __props.currentPage,
          onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (emit('changePage', $event)))
        }, null, 8, ["total", "pageSize", "currentPage"]), [
          [_vShow, __props.displayType !== 'map']
        ]),
        _createVNode(_unref(CameraDetailDialog), {
          modelValue: showCameraInfoDialogFlag.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showCameraInfoDialogFlag).value = $event)),
          cameraData: cameraInfoData.value
        }, null, 8, ["modelValue", "cameraData"])
      ]))
    : (_openBlock(), _createBlock(_unref(ZeroItem), {
        key: 1,
        onClear: _cache[4] || (_cache[4] = ($event: any) => (emit('clearFilter')))
      }))
}
}

})